import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetCountryList extends Event {
    eventName = 'oms_getCountryList';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get countries for given client id
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        // get country list from Local Storage
        let countryList = new LocalStorage.CountryList(clientId);
        let response = countryList.getData();

        if (response?.data) {
            //fire success event
            let timer = setInterval(function () {
                thisObj.onSuccessEvent({
                    "auth_type": "public", 
                    "data": response.data,
                    "data_type": "local",  
                    "success" : true, 
                    "message" : "" 
                },
                {
                    'action' : action, 
                    'request_id' : requestId 
                });
        
                clearInterval(timer);
              }, 10);
        }
        else {
            // request data
            data.endPoint = application_settings.endPoints.countryList;
            let multiCallKey = (data.multi_call_key) ? data.multi_call_key : 'country_list';
            data.multi_call_key = multiCallKey;
            data.method = 'POST';

            this.sendRequest(data, function (response) {
                if (response) {
                    if (response.data?.data?.length) {
                        response.data.data = response.data.data.filter(function(obj) {
                            return !obj.type || obj.type && obj.type == 'country';
                        });
                    }

                    //add data to storage
                    countryList.setData(response);

                    //format response data
                    let data = thisObj.formatResponseData(response);

                    //fire success event
                    thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
                }
            });
        }
    }
}

export default GetCountryList;